<template>
  <div id="payment">
    <BottomBar />
    <Empty
      v-if="!data"
      :loading="data === undefined"
      :icon="true"
      title="暂无支付记录"
      subtitle="您还没有购买课程"
    />
    <div v-else>
      <router-link
        :to="'/order/view?order_id=' + item.r_id"
        v-for="item in data"
        :key="item.id"
        tag="div"
        class="invoice-item"
      >
        <div class="left">
          <h1>
            <span>{{ item.title }}</span>
            <span v-if="item.status == 2" class="refunded">已退款</span>
            <span v-if="item.status == 4" class="refunded">部分退款</span>
          </h1>
          <p>{{ formatTime(item.create_time) }}</p>
        </div>
        <div class="right">
          <h1>
            <sup>¥</sup>
            {{ parseFloat(item.consume).toFixed(2) }}
          </h1>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import Empty from "../public/Empty"
import BottomBar from "../public/footer"
export default {
  name: "PaymentHistory",
  components: {
    Empty,
    BottomBar,
  },
  data() {
    return {
      data: undefined,
      empty: false,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    formatTime(datetime) {
      const time = this.$moment(datetime)
      const today = this.$moment()
      if (today.isSame(time, "day")) {
        return time.format("今天 HH:mm")
      } else if (time.isSame(today.subtract(1, "day"), "day")) {
        return time.format("昨天 HH:mm")
      } else if (time.isSame(today.subtract(2, "day"), "day")) {
        return time.format("前天 HH:mm")
      } else if (time.isSame(today, "week")) {
        return time.format("dddd HH:mm")
      } else if (time.isSame(today, "year")) {
        return time.format("M月D日 HH:mm")
      } else {
        return time.format("YYYY年M月D日 HH:mm")
      }
    },
    getData() {
      this.$axios(window.PHP_ROOT + "/index/User/paymentHistory/")
        .then(({ data }) => {
          const { code, msg } = data
          this.data = code === "1000" ? msg : null
        })
        .catch(error => {
          this.data = null
          this.$toastError("网络错误，请尝试刷新页面")
        })
    },
  },
}
</script>
<style scoped lang="scss">
.center {
  display: flex;
  height: 80vh;
  align-items: center;
  justify-content: space-around;
  font-size: 25px;
  color: $black;
  font-weight: bold;
}
#payment {
  background: white;
  min-height: 100vh;
  width: 100%;
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  padding-top: 15px;
}

.invoice-item {
  width: 90%;
  display: flex;
  padding: 10px 10px;
  margin: 0 auto 10px auto;
  justify-content: space-between;
  border: $border;
  border-radius: 4px;
  background: white;
  box-shadow: $deep-shadow;
  transition: all 0.1s;
  &:active {
    background: $bgd-grey;
    transform: scale(0.98);
  }

  &:last-child {
    margin-bottom: 15px;
  }
  h1 {
    font-size: 1rem;
    margin-bottom: 3px;
  }
  p {
    font-size: 0.875rem;
    font-weight: 400;
    opacity: 0.6;
  }
  .left {
    text-align: left;
    h1 {
      color: $black;
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 0.9rem;
    }
    .refunded {
      font-weight: 400;
      font-size: 0.8rem;
      background: #eee;
      color: $black;
      min-width: 45px;
      padding: 3px 5px;
      border-radius: 3px;
      transform: scale(0.9);
      display: inline-block;
    }
  }
  .right {
    display: flex;
    min-width: 60px;
    align-items: center;
    h1 {
      @include avenir-demi();
      font-weight: 500;
      width: 100%;
      text-align: right;
      color: $red;
      font-size: 17px;
    }
  }
}
</style>
